// ABOUTME: QA-only secret shortcut — Ctrl+Alt+Shift+X wipes all browser-side guest state
// ABOUTME: (intro-seen, session id, token, consent, wishlist mirror) and reloads as a fresh guest.

// The combo is deliberately obscure (no browser default uses it) and requires all three
// modifiers, so a guest cannot hit it by accident. It clears EVERYTHING this origin
// stores — localStorage (versai_seen_intro, versai_sid_*, versai_token*, consent,
// wishlist mirrors) and sessionStorage (versai_sid) — then reloads, so the next entry is
// indistinguishable from a first-ever visit: intro film plays, no returning flag, a brand
// new session id, empty cart and wishlist.

export function isQaResetCombo(event) {
  return !!(
    event &&
    event.ctrlKey && event.altKey && event.shiftKey &&
    String(event.key || '').toLowerCase() === 'x'
  );
}

export function performQaReset(reload = () => window.location.reload()) {
  try { localStorage.clear(); } catch { /* storage unavailable — nothing to wipe */ }
  try { sessionStorage.clear(); } catch { /* ditto */ }
  reload();
}

/** Attach the listener; returns the detach function (for effect cleanup). */
export function installQaReset(target = window) {
  const onKeyDown = (event) => {
    if (!isQaResetCombo(event)) return;
    event.preventDefault();
    performQaReset();
  };
  target.addEventListener('keydown', onKeyDown);
  return () => target.removeEventListener('keydown', onKeyDown);
}
